import { InitialLoadEditSources } from '@confluence/edit-common/entry-points/event-names.ts';

export const isLoadingFromCreate = (editSource: string): boolean =>
	editSource?.indexOf('CREATE_') === 0; // See constants.ts in edit-common

export const isJSOnlyPreloadEditSources = (editSource: string): boolean =>
	isLoadingFromCreate(editSource) || InitialLoadEditSources.includes(editSource);

export const isEditSourceInitialLoad = (editSource: string): boolean =>
	InitialLoadEditSources.includes(editSource);
